import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { EcmToolChangeService } from '../ecm-tool-change.service';
import { EtcAddAuthorityComponent } from './etc-add-authority/etc-add-authority.component';
import { CgpConfirmationDialogService } from 'src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpAlertDialogService, cgpAlertTypes } from 'src/app/shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { EcmService } from '../../ecm.service';
import { LazyLoadEvent } from 'primeng/api/primeng-api';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { filter, finalize } from 'rxjs/operators';

interface ECMAuthority {
   authID: number;
   toolChangeID: number;
   partChangeID: number;
   fmtaddedBy: string;
   fmtaddedDate: string;
   fmtlastUpdatedBy: string;
   fmtlastUpdatedDate: string;
   authNumber: string;
   authNumberN: string;
   authDescription: string;
   authTypeName: string;
}

// ECM Tool Change (ETC) Authorities
@Component({
   // tslint:disable-next-line: component-selector
   selector: 'etc-authorities',
   templateUrl: './etc-authorities.component.html',
   styleUrls: ['./etc-authorities.component.scss']
})
export class EtcAuthoritiesComponent implements OnInit {

   @ViewChild('authorityTable', { static: true }) authorityTable: DataTableComponent;

   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('toolId');

   private _reloadToolChange = false;
   authorities: ECMAuthority[];
   selectedAuthority;
   total = 0;
   loading = false;
   resourced = false;

   columns: ColumnDef[] = [
      { field: 'authNumber', name: 'Auth. # (alpha)', editable: false, width: '6em', tooltip: 'Authority Number (alpha) is a required entry when choosing EWO as the Authority Type.' },
      { field: 'authNumberN', name: 'Auth. # (numeric)', editable: false, width: '6em', tooltip: 'Authority Number (numeric) is a required entry.' },
      { field: 'authTypeName', name: 'Authority Type', editable: false, width: '6em', tooltip: 'Authority Type is a required entry.' },
      { field: 'authDescription', name: 'Description', editable: false, width: '22em' }
   ];

   constructor(
      private readonly router: Router,
      private readonly dialogRef: MatDialogRef<EtcAuthoritiesComponent>,
      private readonly cgpConfirmationDialogService: CgpConfirmationDialogService,
      private readonly cgpAlertDialogService: CgpAlertDialogService,
      private readonly ecmToolChangeService: EcmToolChangeService,
      private readonly ecmService: EcmService,
      private readonly dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public readonly data: any,
      private readonly toastr: ToastrService,
      private readonly dataTableService: DataTableService
   ) { }

   get hasSelectedSingle(): boolean {
      return (this.authorityTable.selections || [])
         .filter((row) => Object.keys(row).length !== 0).length === 1;
   }

   ngOnInit() {
      if (this.router.url === '/tprecm/ecm/re-source') {
         this.resourced = true;
         this.columns.forEach(val => { val.editable = false; val.headerHighlight = false; });
      }

      if (this.resourced) {
         this.columns.forEach(val => {
            if (val.field === 'authDescription') {
               return (val.type = 'readonly');
            }
         });
      }

      if (this.data.selected.partNumber) {
         this.columns.forEach(val => {
            if (val.field === 'authDescription') {
               return (val.editable = true);
            }
            if (val.field === 'authNumber' || val.field === 'authNumberN' || val.field === 'authTypeName') {
               return (val.headerHighlight = true);
            }
         });

      }

      this.loadAuthorities();
   }

   onLazyLoad(event: LazyLoadEvent) {
      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = event.sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;
      this.loadAuthorities();
   }

   loadAuthorities(authId?: any, isdeleted = false) {
      this.loading = true;
      const pageOptions = {
         page: 0,
         order: 'asc',
         size: 10,
         sort: 'authNumber',
      } as PageOptions;

      this.ecmService.getAuthorities(this.data.selected.toolChangeId, pageOptions)
         .pipe(
            finalize(() => {
               if (authId || authId !== null) {
                  const auth = this.authorities.find(authority => authority.authID === authId);
                  if (auth) {
                     this.authorityTable.selections = [auth];
                  }
               }
               if (isdeleted) {
                  this.clearSelections();
               }

               this.loading = false;
            })
         ).subscribe((res?: { totalCount: number, data: any[] }) => {
            if (res) {
               this.authorities = res.data;
               this.total = res.totalCount;
            }
         });
   }

   clearSelections() {
      this.authorityTable.selections = [];
   }


   onAuthoritySelect(dataItem) {
      this.selectedAuthority = dataItem;
   }

   onCloseClick() {
      this.dialogRef.close({
         reload: this._reloadToolChange,
         toolChangeId: this.data.selected.toolChangeId
      });
   }

   onDeleteClick(dataItem) {
      if (this.selectedAuthority) {
         this.cgpConfirmationDialogService.showConfirmationDialog({
            title: 'Delete Authority',
            message: `Are you sure you want to delete this authority?`,
            alert: alert,
            onYesClick: () => {
               this.loading = true;
               this.ecmToolChangeService.deleteAuthority(dataItem.authID, this.data.selected.toolChangeId)
                  .subscribe(
                     res => {
                        this.cgpAlertDialogService.showAlertDialog({
                           title: 'Delete Successful',
                           message: 'Authority was successfully deleted!',
                           alert: cgpAlertTypes.success,
                           closeLabel: 'OK'
                        }).afterClosed().subscribe({
                           complete: () => {
                              const isdeleted = true;
                              this._reloadToolChange = true;
                              this.loadAuthorities(null, isdeleted);
                           }
                        });
                     },
                     error => {
                        this.cgpAlertDialogService.showAlertDialog({
                           title: 'Delete Unsuccessful',
                           message: 'Authority was not deleted. Please try again!',
                           alert: cgpAlertTypes.danger,
                           closeLabel: 'OK'
                        });
                     },
                     () => {
                        this.loading = false;
                     }
                  );
               this.cgpConfirmationDialogService.closeConfirmationDialog();
            },
            onNoClick: () => {
               this.cgpConfirmationDialogService.closeConfirmationDialog();
            }
         });
      } else {
         this.toastr.error('Please select an authority to delete.');
         return;
      }
   }

   onAddAuthorityClick() {
      this.dialog.open(EtcAddAuthorityComponent,
         {
            autoFocus: true,
            disableClose: true,
            data: {
               isNew: true,
               selectedTool: this.data.selected
            }
         }).afterClosed().subscribe((res) => {
            if (res && res.reload) {
               this._reloadToolChange = true;
               this.loadAuthorities();
            }
         });
      this.clearSelections();
   }

   onEditAuthorityClick() {
      if (!this.selectedAuthority) {
         this.toastr.error('Please select an authority to Update.');
      }
      else {
         this.dialog.open(EtcAddAuthorityComponent,
            {
               autoFocus: true,
               disableClose: true,
               data: {
                  isNew: false,
                  selectedTool: this.data.selected,
                  selected: this.authorityTable.selections[0],
                  selections: this.authorityTable.selections,
               }
            }).afterClosed().subscribe((res) => {
               if (res && res.reload) {
                  this._reloadToolChange = true;
                  this.loadAuthorities(res.authId, null);
               }
            });
      }
   }

   updateAuthorityChange(event: any) {
      const body = event.data;
      body.authDescription = body.authDescription ? body.authDescription.toUpperCase() : body.authDescription;
      this.ecmToolChangeService.updateAuthority(body)
         .subscribe();
   }

}
